import {createSelector} from '@reduxjs/toolkit';

import {LABS_MAP, TILE_MODE, UI_MODES} from '@explorer/constants';
import {selectFilteredResultsList} from './results.js';

export const getActiveMenuId = state => state.ui.menu.activeTabId;

export const getSarDataLab = state => state.labs[LABS_MAP.SAR_DATA] === true;

const UIMode = state => state.ui.mode;
const tileMode = state => state.tiles.mode;
const getSelectedSeries = state => state.series.selectedId;
const getActiveSeries = state => state.series.activeId;
const getSelectedMosaic = state => state.mosaics.selected;

export const showTimeline = createSelector(
  [
    UIMode,
    tileMode,
    selectFilteredResultsList,
    getSelectedSeries,
    getActiveSeries,
    getSelectedMosaic,
  ],
  (uiMode, tileMode, results, selectedSeries, activeSeries, selectedMosaic) => {
    if (tileMode === TILE_MODE.FOLDERS || uiMode === UI_MODES.COMPARE) {
      return false;
    }

    return (
      !!(
        tileMode === TILE_MODE.BASEMAPS &&
        (activeSeries || (selectedSeries && selectedMosaic))
      ) || !!(tileMode === TILE_MODE.RESULTS && results.length)
    );
  }
);
